var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"contacts__list"},_vm._l((_vm.contacts),function(contact){return _c('ContactsItem',{key:contact.id,attrs:{"contact":contact}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }